// extracted by mini-css-extract-plugin
var _1 = "webpack-pages-DataExtraction-QualityAssessmentTemplate-QaConfirmationDialog-module__ConfirmationDialog_text";
export { _1 as "ConfirmationDialog_text" }
